// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template >
  <div class="main">
    <!-- Navbar -->
    <navbar/>
    <!-- Register -->
    <div v-if="this.$route.name =='Register'" class="container login">
      <h4 class="title">Register</h4>
      <br>
      <form v-on:submit.prevent='handleRegFormSubmit'> 
        <fieldset>
          <div >
            <div class="form-group">
              <label class="label" for="email"><h4>Email address</h4></label>
              <input 
                type="email" 
                class="form-control inline input" 
                id="email" 
                aria-describedby="emailHelp" 
                placeholder="Enter email"
                v-model="email"
              >
            </div>
            <div class="form-group">
              <label class="label" for="username"><h4>Username</h4></label>
              <input 
                type="text" 
                class="form-control inline input" 
                id="username" 
                aria-describedby="emailHelp" 
                placeholder="Enter Username"
                v-model="username"
              >
            </div>
            <div class="form-group">
              <label class="label" for="username"><h4>First Name</h4></label>
              <input 
                type="text" 
                class="form-control inline input" 
                id="first_name" 
                aria-describedby="emailHelp" 
                placeholder="Enter First Name"
                v-model="first_name"
              >
            </div>
            <div class="form-group">
              <label class="label" for="username"><h4>Last Name</h4></label>
              <input 
                type="text" 
                class="form-control inline input" 
                id="last_name" 
                aria-describedby="emailHelp" 
                placeholder="Enter Last Name"
                v-model="last_name"
              >
            </div>
            <div class="form-group">
                <label class="label" for="password"><h4>Password</h4></label>
                <input 
                  type="password" 
                  class="form-control inline input" 
                  id="password" 
                  placeholder="Password"
                  v-model="password"
                >
            </div>
            <div class="functions">
              <div class="options-box">
                 <router-link style="color: #B2B3B4" to="/users/login">Login </router-link>
                <!-- <a style="margin-bottom: 10px">Forgot Password</a>
                <a> Create Account</a> -->
              </div>
              <div class="submit-button">
                <button type="submit" class="btn ">Register</button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <!-- Login -->
    <div v-if="this.$route.name =='Login'" class="container login">
      <h4 class="title">Login</h4>
      <br>
      <form v-on:submit.prevent='handleLoginFormSubmit'> 
        <fieldset>
          <div>
            <div class="form-group">
              <label class="label" for="email"><h4>Email address</h4></label>
              <input 
                type="email" 
                class="form-control inline input" 
                id="email" 
                aria-describedby="emailHelp" 
                placeholder="Enter email"
                v-model="email"
              >
            </div>
            <div class="form-group">
                <label class="label" for="password"><h4>Password</h4></label>
                <input 
                  type="password" 
                  class="form-control inline input" 
                  id="password" 
                  placeholder="Password"
                  v-model="password"
                >
            </div>
            <div class="functions">
              <div class="options-box">
                <a href="#" style="color: #B2B3B4; margin-bottom: 10px">Forgot Password</a>
                <router-link style="color: #B2B3B4 " to="/users/register">Create Account </router-link>
           
              </div>
           
              <div class="submit-button">
                <button type="submit" class="btn ">Login</button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
import navbar           from '../navbar.vue'

export default {
  name: 'Register',
  components:{
    navbar,
  },
  data() {
    return {
      mode:       'login',
			email:      '',
      password:   '',
      username:   '',
      first_name: '',
      last_name:  '',
    }
  },
  methods: {
    handleRegFormSubmit() {
			this.$store.dispatch('register', {
        username: this.username,
				email: this.email,
        password: this.password,
        first_name: this.first_name,
        last_name: this.last_name
      })
    },
    handleLoginFormSubmit() {
			this.$store.dispatch('login', {
				email: this.email,
				password: this.password
			})
    },
    getMode(){
      return this.mode
    }
  },
  created(){
    console.log(this)
  }
}
</script>

<style scoped>
@import '../../assets/css/custom.css';
@import '../../assets/css/toolkit-inverse.css';
body {
  background-color: #191b20;
}
.main-container {
  width: 100%;
  height: 100%;
  text-align: center !important;
}
.title {
  font-size: 22pt !important;
  color: #B2B3B4 !important;
}
.gixcore-div {
text-align: center !important;
  border: 1px solid white;
  position: relative;
}
.navbar-sm{
  margin-top: 40px;
}
.container.login {
    margin-top: 10% !important;
    max-width: 450px;
    min-height: 100px;
    border: 2px solid #434857;
    border-radius: 6px;
    text-align: left;
    padding: 15px;
}
.inline-block {
	display: inline-block !important;
}
.inline {
    display: inline !important;
}
.input {
    max-width: 230px;
    float: right;
}
.label {
    margin-top: 5px;
}
.btn {
    font-size: 15px !important;
    text-transform: uppercase;
    background-color: #434857 !important;
    min-width: 100px;
    color: #B2B3B4;
    font-weight: bold;
}
.btn:hover {
    color: #B2B3B4;
    border: 1px solid #B2B3B4;
}
.options-box {
  display: inline-block;
 width: 40%;
}
.options-box a {
  display: block;
}
.submit-button {
  vertical-align: bottom;
  display: inline-block;
  text-align: right;
  width: 60%;
}
.functions{
  color: #9198aa !important;
  text-transform: uppercase;
}
</style>
